$(() => {
  const $item = $("[data-js-ico-item]")

  $(document).on("scroll:ico", () => {
    $item.addClass("_show")
  })
})



// WEBPACK FOOTER //
// ./src/blocks/07.how-it-works/how-it-works.js